import React from "react";
import styled from 'styled-components';
import { connect } from 'react-redux';
import Scrollbars from 'react-custom-scrollbars';
import Button from '../../../atoms/button';
import MsxIcons from '../../msx-icons';
import I10n from '../../../features/i10n';
import { accessoriesType } from '../../../constants';
import ProductInformationCache from '../../../persistence/description-cache';
import { SECONDARY_COLOR } from "../../../color-constants";

const Container = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 2em;
  max-width: 1100px;
  width: 100%;
  background-color: white;
  height: calc(100vh - 4em);
  overflow: hidden;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
  border-bottom: 2px solid ${SECONDARY_COLOR};
  border-bottom: 2px solid var(--se-primary, ${SECONDARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: 10px 20px 20px;
`;

const Content = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
  overflow: hidden;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const AccessoriesSectionContent = styled.div`
  position: relative;
  flex: 1 1 auto;
  background-color: #fafafa;
  padding: 10px;
  margin-top: 10px;
  border-left: solid 1px #e5e5e5;
  overflow: auto;
`;

const AccessoriesSection = styled.section`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
`;

const NavigationButtonSection = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

const AccessoryWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  background-color: ${props => props.selected ? '#eaeaea' : 'white'};
  margin-bottom: 15px;
  box-shadow: 0px 2px 4px 0px rgba(198,198,198,0.5);
  padding: 10px;
  cursor: pointer;
`;

const AccessoryImage = styled.img`
  height: 50px;
  width: 50px;
`;

const AccessoryInformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
`;

const AccessoryTitle = styled.span`
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 10px;
`;

const AccessoryDescription = styled.span`
  color: #626469;
  font-size: 13px;
  line-height: 18px;
`;

const EmptyResultText = styled.span`

`;

class ModalDeviceAccessories extends React.PureComponent {

  constructor(props) {
    super(props);
    this._isMounted = false;

    this.state = {
      accessories: [],
      accessorySelected: null,
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateStateIfMounted(objectToAffect) {
    if (this._isMounted) {
      return this.setState(objectToAffect);
    }
  }

  get hasSelection() {
    return this.state.accessorySelected !== null;
  }

  renderAccessory = (accessory, key) => {
    const description = ProductInformationCache.getDescription(accessory);
    return (
      <AccessoryWrapper key={key} onClick={() => { this.updateStateIfMounted({ accessorySelected: accessory }) }}
        selected={this.state.accessorySelected === accessory}>
        <AccessoryImage src={`https://gw-api.schneider-electric.com/sc/products/image/${accessory}?width=50&height=50`}></AccessoryImage>
        <AccessoryInformationWrapper>
          <AccessoryTitle>{accessory}</AccessoryTitle>
          <AccessoryDescription title={description}>{description}</AccessoryDescription>
        </AccessoryInformationWrapper>
      </AccessoryWrapper>
    );
  }

  renderModalTitle = () => {
    let title;
    const accessoryType = this.props.accessoryType;
    if (accessoryType === accessoriesType.accessory) {
      title = 'screen.config_editor.add_accessories';
    } else if (accessoryType === accessoriesType.warranty) {
      title = 'screen.config_editor.add_warranty';
    } else if (accessoryType === accessoriesType.auxiliary) {
      title = 'screen.config_editor.add_auxiliary';
    } else if (accessoryType === accessoriesType.sensor) {
      title = 'screen.config_editor.add_sensor';
    } else if (accessoryType === accessoriesType.spare_part) {
      title = 'screen.config_editor.add_spare_parts';
    }
    return <Title>{I10n.get(title)}</Title>
  }

  renderEmptyResultText = () => {
    let text;
    const accessoryType = this.props.accessoryType;
    if (accessoryType === accessoriesType.accessory) {
      text = I10n.get('screen.config_editor.accessory_empty');
    } else if (accessoryType === accessoriesType.warranty) {
      text = I10n.get('screen.config_editor.warranty_empty');
    } else if (accessoryType === accessoriesType.auxiliary) {
      text = I10n.get('screen.config_editor.auxiliary_empty');
    } else if (accessoryType === accessoriesType.sensor) {
      text = 'screen.config_editor.sensor_empty';
    } else if (accessoryType === accessoriesType.spare_part) {
      text = 'screen.config_editor.spare_part_empty';
    }
    return text;
  }

  renderButtonText = () => {
    let text;
    const accessoryType = this.props.accessoryType;
    if (accessoryType === accessoriesType.accessory) {
      text = I10n.get('screen.config_editor.accessory_modal_add');
    } else if (accessoryType === accessoriesType.warranty) {
      text = I10n.get('screen.config_editor.warranty_modal_add');
    } else if (accessoryType === accessoriesType.auxiliary) {
      text = I10n.get('screen.config_editor.auxiliary_modal_add');
    } else if (accessoryType === accessoriesType.sensor) {
      text = I10n.get('screen.config_editor.sensor_modal_add');
    } else if (accessoryType === accessoriesType.spare_part) {
      text = I10n.get('screen.config_editor.spare_part_modal_add');
    }
    return text;
  }

  handleConfirmation = () => {
    const accessoryType = this.props.accessoryType;
    if (accessoryType === accessoriesType.accessory) {
      this.props.addModuleAccessory(this.state.accessorySelected);
    } else if (accessoryType === accessoriesType.warranty) {
      this.props.setModuleWarranty(this.state.accessorySelected);
    } else if (accessoryType === accessoriesType.auxiliary) {
      this.props.addModuleAuxiliary(this.state.accessorySelected);
    } else if (accessoryType === accessoriesType.sensor) {
      this.props.addModuleSensor(this.state.accessorySelected);
    } else if (accessoryType === accessoriesType.spare_part) {
      this.props.addModuleSparePart(this.state.accessorySelected);
    }
    this.props.closeModal();
  }

  render = () => {
    return (
      <Container>
        <Header>
          {this.renderModalTitle()}
          <CloseIcon onClick={(e) => {
            e.preventDefault();
            this.props.closeModal();
          }}>
            <MsxIcons name="close"></MsxIcons>
          </CloseIcon>
        </Header>
        <Body>
          <Content>
            <AccessoriesSection>
              <AccessoriesSectionContent>
                <Scrollbars>
                  {this.props.candidateAccessories?.length === 0 &&
                    <EmptyResultText>{this.renderEmptyResultText()}</EmptyResultText>}
                  {this.props.candidateAccessories.map((accessory, key) => this.renderAccessory(accessory, key))}
                </Scrollbars>
              </AccessoriesSectionContent>
            </AccessoriesSection>
          </Content>
          <NavigationButtonSection>
            <Button  primary disabled={!this.hasSelection}
              onClick={this.handleConfirmation}
            >
              {this.renderButtonText()}
            </Button>
          </NavigationButtonSection>
        </Body>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

export default connect(mapStateToProps)(ModalDeviceAccessories);
